import styled, { createGlobalStyle } from "styled-components/macro";
import { Popup } from "react-map-gl";

import {
  borderRadius,
  colors,
  space,
  fontStyle,
  fontSize,
} from "shared/styles/constants";

export const StyledDragPopup = styled(Popup)`
  color: ${colors.black};

  .mapboxgl-popup-content {
    border-radius: ${borderRadius.xs};

    padding: ${space.xs};

    ${fontStyle.regular};
    ${fontSize.xs};
  }
`;

export const GlobalMapStyle = createGlobalStyle`
  .mapboxgl-ctrl.mapboxgl-ctrl-attrib {
    width: 100%;

    background-color: ${colors.blackLight};
    border-top-left-radius: ${borderRadius.s};

    a {
      border-bottom: none !important;
      color: ${colors.grey4};
    }
  }

  .mapboxgl-ctrl-attrib-inner {
    display: flex;

    > * + * {
      margin-left: ${space.xs} !important;
    }
  }

  .mapboxgl-ctrl-attrib-button {
    &:hover {
      background-color: ${colors.white} !important;
    }
  }
`;
